import { useEffect, useState } from "react";

export default function ShopImage({
  src,
  alt = "",
  imgClassName = "",
  fallbackClassName = "",
  fallbackLabel = "No image",
  ...imgProps
}) {
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    setFailed(false);
  }, [src]);

  if (!src || failed) {
    return <div className={fallbackClassName}>{fallbackLabel}</div>;
  }

  return (
    <img
      {...imgProps}
      src={src}
      alt={alt}
      className={imgClassName}
      onError={() => setFailed(true)}
    />
  );
}